import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { Alert } from '../../../models/alert.model';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
})
export class ConfigurationComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() data: any;
  content: string;
  datosFormulario: FormGroup;

  @Output() public emitActionPlanData = new EventEmitter();

  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private modalService: NgbModal,
    private globals: GlobalsService
  ) {}

  ngOnInit(): void {
    this.datosFormulario = this.fb.group({
      unidad: [
        { value: this.data.unidad, disabled: this.from },
        Validators.required,
      ],
      aviso: [{ value: this.data.aviso, disabled: this.from }],
      unidad_monetaria: [
        { value: this.data.unidad_monetaria, disabled: this.from },
      ],
      configuration: [this.data.configuration],
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.datosFormulario.patchValue({
      unidad: this.data.unidad,
      aviso: this.data.aviso,
      unidad_monetaria: this.data.unidad_monetaria,
    });
  }
  btnClose() {
    if (this.datosFormulario.valid) {
      this.datosFormulario.patchValue({ configuration: true });
      this.clickClose.emit(this.datosFormulario.value);
      this.activeModal.close();
    } else {
      this.alert();
    }
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }
  emitData(): void {
    this.emitActionPlanData.emit(this.datosFormulario.value);
  }

  alert() {
    Alert.buildErrorAlert(
      this.translate.instant('action_plan.modal_save.error_empty')
    );
    this.validateAllFormFields(this.datosFormulario);
  }
  /**
   * @name validateAllFormFields
   * @author Daniel Ramirez
   * @description recorre el formulario en busca de campos requeridos vacios y manda la informacion
   * para la alerta
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
